"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EspoolConfigurationGuard = void 0;
const EspoolConfiguration_1 = require("./EspoolConfiguration");
class EspoolConfigurationGuard {
    static isEspoolConfiguration(configuration) {
        return configuration instanceof EspoolConfiguration_1.EspoolConfiguration;
    }
}
exports.EspoolConfigurationGuard = EspoolConfigurationGuard;
//# sourceMappingURL=EspoolConfigurationGuard.js.map